import api from "./api";

export const getBookings = async (params) => {
  const response = await api({
    method: "GET",
    url: "/bookings",
    params,
  });

  return response;
};

export const updateBooking = async (id, data) => {
  const response = await api({
    method: "PUT",
    url: `/bookings/${id}`,
    data,
  });

  return response;
};

export const updateBookingItem = async (id, data) => {
  const response = await api({
    method: "PUT",
    url: `/booking-items/${id}`,
    data,
  });

  return response;
};

export const checkNewBookings = async () => {
  const response = await api({
    method: "GET",
    url: "/bookings/check-new",
  });
  return response;
};
